import { useState, useEffect } from "react";
import { Container, Table, Form, InputGroup, Button } from "react-bootstrap";
import axios from "axios";
import { useNavigate } from 'react-router-dom';
import { useAuth } from "./AuthContext";
import {SERVER_BASE_URL} from "../Constants";

export default function CompetitionsPage() {
    const [competitions, setCompetitions] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");

    const { isAdmin } = useAuth();

    const navigate = useNavigate();

    const filteredCompetitions = competitions.filter((competition) =>
        competition.competition_name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const handleCreate = () => {
        navigate('/competitions/create');
    }

    const handleView = (competition) => {
        navigate(`/competition/${competition.competition_id}`);
    };

    useEffect(() => {
        const fetchCompetitions = async () => {
            try {
                const response = await axios.get(SERVER_BASE_URL + 'api/competitions');
                console.log(response.data);
                console.log(response.data[0]);

                // Handle successful response
                if (response.status === 200) {
                    setCompetitions(response.data);
                } else {
                    console.log(response);
                }
            } catch (err) {
                // Handle API errors
                console.log(err);
            }
        };
        fetchCompetitions();
    }, []);

    return (
        <Container className="mt-4">
            <h2 className="text-center mb-4">Competitions</h2>
            <InputGroup className="mb-3">
                <InputGroup.Text>Filter</InputGroup.Text>
                <Form.Control
                    type="text"
                    placeholder="Search competitions..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                />
            </InputGroup>
            <Table striped bordered hover>
                <thead>
                <tr>
                    <th>Name</th>
                    <th>Description</th>
                    <th>Start Date</th>
                    <th>End Date</th>
                    <th>Actions</th>
                </tr>
                </thead>
                <tbody>
                {filteredCompetitions.map((competition) => (
                    <tr key={competition.competition_id}>
                        <td>{competition.competition_name}</td>
                        <td>{competition.competition_name}</td>
                        <td>{new Date(competition.start_date).toLocaleDateString("en-uk")}</td>
                        <td>{new Date(competition.end_date).toLocaleDateString("en-uk")}</td>
                        <td>
                            <Button variant="link" size="sm" onClick={() => handleView(competition)}>
                                View
                            </Button>
                        </td>
                    </tr>
                ))}
                </tbody>
            </Table>{
            isAdmin() ? (
                <div className="text-center mt-3">
                    <Button variant="outline-primary" size="lg" onClick={() => handleCreate()} >Create Competition</Button>
                </div>
            ) : (
                <></>
            )
        }

        </Container>
    );
}
